import {
  BlotterTable,
  createInputFocusGridInnerElementHandler,
  DEFAULT_BLOTTER_SELECTION_READONLY_PARAMS,
  useBlotterTable,
} from '@talos/kyoko';
import type { ModifyFixingEntry } from './modifyFixingSlice';
import {
  modifyFixingInputID,
  modifyTotalInputID,
  useModifyFixingBlotterColumns,
} from './useModifyFixingBlotterColumns';
import { useModifyFixingBlotterDataObs } from './useModifyFixingBlotterDataObs';

interface ModifyFixingBlotterProps {
  entries: ModifyFixingEntry[];
  onEntryFixingChange: (symbol: string, value: string | undefined) => void;
  onEntryPriceChange: (symbol: string, value: string | undefined) => void;
  onEntryAmountChange: (symbol: string, value: string | undefined) => void;
}

export const ModifyFixingBlotter = ({
  entries,

  onEntryFixingChange,
  onEntryPriceChange,
  onEntryAmountChange,
}: ModifyFixingBlotterProps) => {
  const dataObservable = useModifyFixingBlotterDataObs(entries);
  const columns = useModifyFixingBlotterColumns({
    onEntryFixingChange,
    onEntryPriceChange,
    onEntryAmountChange,
  });

  const blotterTable = useBlotterTable<ModifyFixingEntry>({
    dataObservable,
    errorObservable: undefined,
    rowID: 'symbol' satisfies keyof ModifyFixingEntry,
    applyTransactionsSynchronously: true, // immediate blotter updates since we're doing inline editing
    gridOptions: {
      // Keep AG Grid row containers out of the tab order so Tab moves between inline inputs.
      tabIndex: -1,
      rowSelection: DEFAULT_BLOTTER_SELECTION_READONLY_PARAMS,
      rowHeight: 106, // this height renders the contents (including cell warnings) well within one cell
      suppressHeaderFocus: true,
      focusGridInnerElement: createInputFocusGridInnerElementHandler({
        getTopInputID: modifyFixingInputID,
        getBottomInputID: modifyTotalInputID,
      }),
    },
    columns,
  });

  return <BlotterTable {...blotterTable} />;
};
